import './App.css';
import Parking from './Parking-lot.png';
import logo from './ํY&B.jpg';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Login from "./Login";
import Registered from "./registered";
import React, { useEffect, useState } from 'react';

import { getDatabase, ref, get } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';      // ใช้ Firestore
import { getAuth } from 'firebase/auth';                // ใช้ Authentication
import { getStorage } from 'firebase/storage';          // ใช้ Storage

const firebaseConfig = {
  apiKey: "AIzaSyAjjlwqKRBamekFxOryEYvBvj1B5djr-2g",
  authDomain: "clinic-bb643.firebaseapp.com",
  databaseURL: "https://clinic-bb643-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "clinic-bb643",
  storageBucket: "clinic-bb643.firebasestorage.app",
  messagingSenderId: "634326842792",
  appId: "1:634326842792:web:9569cee6f1637d46ca319d",
  measurementId: "G-RJ6Q06NJY1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
// Export modules
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registered" element={<Registered />} />
        {/* <Route path="/bar-chart" element={<BarChartPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

function Home() {
  const navigate = useNavigate();

  const [value11, setA1] = useState(null);
  const [value12, setA2] = useState(null);
  const [value13, setA3] = useState(null);
  const [value14, setA4] = useState(null);
  const [value21, setB1] = useState(null);
  const [value22, setB2] = useState(null);
  const [value23, setB3] = useState(null);
  const [value24, setB4] = useState(null);
  const [value31, setC1] = useState(null);
  const [value32, setC2] = useState(null);
  const [value33, setC3] = useState(null);
  const [value34, setC4] = useState(null);
  const [value41, setD1] = useState(null);
  const [value42, setD2] = useState(null);
  const [value43, setD3] = useState(null);
  const [value44, setD4] = useState(null);
  const [value45, setD5] = useState(null);
  const [occ, setTotal] = useState(0);
  const lots = 17;
  const [time, settime] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const keys = ['A1', 'A2', 'A3', 'A4','B1', 'B2', 'B3', 'B4','C1', 'C2', 'C3', 'C4','D1', 'D2', 'D3', 'D4','D5',
        'timestamp'];
      const promises = keys.map(key =>
        get(ref(database, `Y&B_Clinic/${key}`))
      );

      const snapshots = await Promise.all(promises);

      if (snapshots[0].exists()) setA1(snapshots[0].val());
      if (snapshots[1].exists()) setA2(snapshots[1].val());
      if (snapshots[2].exists()) setA3(snapshots[2].val());
      if (snapshots[3].exists()) setA4(snapshots[3].val());
      if (snapshots[4].exists()) setB1(snapshots[4].val());
      if (snapshots[5].exists()) setB2(snapshots[5].val());
      if (snapshots[6].exists()) setB3(snapshots[6].val());
      if (snapshots[7].exists()) setB4(snapshots[7].val());
      if (snapshots[8].exists()) setC1(snapshots[8].val());
      if (snapshots[9].exists()) setC2(snapshots[9].val());
      if (snapshots[10].exists()) setC3(snapshots[10].val());
      if (snapshots[11].exists()) setC4(snapshots[11].val());
      if (snapshots[12].exists()) setD1(snapshots[12].val());
      if (snapshots[13].exists()) setD2(snapshots[13].val());
      if (snapshots[14].exists()) setD3(snapshots[14].val());
      if (snapshots[15].exists()) setD4(snapshots[15].val());
      if (snapshots[16].exists()) setD5(snapshots[16].val());
      if (snapshots[17].exists()) settime(snapshots[17].val());

      let sum = 0;
      for (let i = 0; i < 17; i++) {
        if (snapshots[i].exists()) {
          sum += parseInt(snapshots[i].val(), 10);
        }
      }
      setTotal(sum);
    };

    fetchData(); // เรียกครั้งแรก
    const interval = setInterval(fetchData, 5000); // เรียกทุก 5 วิ

    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="App">
      <div className="App-header_app">
        SMART PARKING LOT
      </div>
      <div className="body_app">
        <div className="body_left_app">
          <div className="body_left_head_app">
            Y&B Dental Clinic
          </div>
          <div className="logo_box_app">
            <img src={logo} alt="none" style={{ width: '100%' ,height: '100%' ,maxWidth: '100%' ,display: 'block'}} />
          </div>
          <div className="body_left_right_app">
            {/* <div>
              Available
            </div>
            <br/>
            <div>
              Unvailable
            </div> */}
            <div className='Available_box'>
              Available
            </div>
            <div className='Unvailable_box'>
              Unvailable
            </div>
            <div className='Time_box'>
              Updated: {time}
            </div>
            <div className='green_box_app' style={{ color: 'white' }}>
              {lots - occ}
            </div>
            <div className='red_box'>
              {occ}
            </div>
          </div>
          {/* <button className='login_box' onClick={() => navigate("/login")} style={{ cursor: "pointer"}}>
            เข้าสู่ระบบ
          </button> */}
          <div className='login_box_new'>
            <div onClick={() => navigate("/login")} style={{cursor: 'pointer',fontFamily: 'Roboto, sans-serif'}}>
              เข้าสู่ระบบ
            </div>
          </div>
        </div>
        <div className="body_right">
          <img src={Parking} alt="none" style={{ width: '100%' ,height: '100%' ,display: 'block'}} />
          <div className="box_row_1_1" style={{backgroundColor: value11 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_1_2" style={{backgroundColor: value12 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_1_3" style={{backgroundColor: value13 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_1_4" style={{backgroundColor: value14 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_2_1" style={{backgroundColor: value21 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_2_2" style={{backgroundColor: value22 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_2_3" style={{backgroundColor: value23 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_2_4" style={{backgroundColor: value24 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_3_1" style={{backgroundColor: value31 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_3_2" style={{backgroundColor: value32 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_3_3" style={{backgroundColor: value33 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_3_4" style={{backgroundColor: value34 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_4_1" style={{backgroundColor: value41 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_4_2" style={{backgroundColor: value42 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_4_3" style={{backgroundColor: value43 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_4_4" style={{backgroundColor: value44 === 0 ? 'green' : 'red',}}></div>
          <div className="box_row_4_5" style={{backgroundColor: value45 === 0 ? 'green' : 'red',}}></div>
        </div>
      </div>
      <div className="footer_app">
        The Smart Vehicle Detection and Counting System for Parking Lots Using Machine Learning Algorithms
        <span style={{ color: '#93B4D9' }}>
          City Research and Deveopment Center, Faculty of Engineering
        </span>
        <span style={{ color: '#93B4D9' }}>
          Chiang Mai University
        </span>
      </div>
    </div>
  );
}

export default App;
